// extracted by mini-css-extract-plugin
export default {"card":"X2-z","carouselContainer":"Y2-z","carouselContainerOverrides":"Z2-z","carouselContent":"_2-z"};